module.exports = __webpack_public_path__ + "static/media/ng.727becd4.webp";